// Import react libs
import { createClient } from '@supabase/supabase-js';

const databaseUrl = process.env.REACT_APP_DATABASE_URL;
const databaseAnonKey = process.env.REACT_APP_DATABASE_ANON_KEY;

const databaseClient = createClient(databaseUrl, databaseAnonKey);

export default databaseClient;
